import groq from 'groq';

export const createGridWithGridItemId = (componentSet: string) => groq`
  layout {
    ...,
    gridItems[]{
      ...,
      component->{
        ...,
        "itemId": select(
          defined(^.id) => ^.id,
          _id
        ),
        ${componentSet}
      }
    }
  }
`;

export const createGrid = (componentSet: string) => groq`
  layout {
    ...,
    gridItems[]{
      ...,
      component->{
        ...,
        ${componentSet}
      }
    }
  }
`;
